import React from 'react';
import {Box, VStack, HStack, Heading, Pressable} from 'native-base';
import {IRequestsToSyncItem} from '../../../../../interfaces/dtos/requests-to-sync.interface';
import {
  ArrowRightIcon,
  PaymentsIcon,
  ProfileIcon,
  RejectedIcon,
} from '../../../../../components/icons';
import {INewClientRequest} from '../../../../../interfaces/dtos';
import {IProofPaymentRequest} from '../../../../../interfaces/dtos/proof-payment-request.interface';
import {message as t} from '../../../../../utils/messages';
import {ProofType} from '../../../../../constants/enumerations';
import {IOrderRequest} from '../../../../../interfaces/services/order-request.interface';
import SalesOrderIcon from '../../../../../components/icons/sales-order';

interface ItemProps {
  onPress?: () => void;
  rowType: 'odd' | 'even';
  item: IRequestsToSyncItem;
  status: 'processed' | 'sending' | 'waiting' | 'failed';
}

const WithoutConnectionRequestListItem = (props: ItemProps) => {
  const {item, rowType, onPress, status} = props;

  const getStripedColor = () => {
    if (rowType === 'odd') {
      return '#FFFFFF';
    }
    return '#F3F9FF';
  };

  const handleOnPress = () => {
    if (onPress) {
      onPress();
    }
  };

  const getProofPaymentTypeLabel = (value: ProofType) => {
    switch (value) {
      case ProofType.payment:
        return t('syncronization-list-item-proof-type-payment');
      case ProofType.vatTax:
        return t('syncronization-list-item-proof-type-vat-tax');
      case ProofType.incomeTax:
        return t('syncronization-list-item-proof-type-income-tax');
    }
    return '';
  };

  const getName = () => {
    if (item.workflow === 'customer-registration') {
      return (item.request as INewClientRequest).legalName;
    }
    if (item.workflow === 'payment-proof') {
      return `${(item.request as IProofPaymentRequest).client?.name}`;
    }
    if (item.workflow === 'salesman-order') {
      return `${(item.request as IOrderRequest).clientName}`;
    }
    return '';
  };

  const getCategory = () => {
    if (item.workflow === 'customer-registration') {
      return t('syncronization-list-category-new-customer');
    }
    if (item.workflow === 'payment-proof') {
      return `${t(
        'syncronization-list-category-payment-proof',
      )}: ${getProofPaymentTypeLabel(
        (item.request as IProofPaymentRequest).type,
      )}`;
    }
    if (item.workflow === 'salesman-order') {
      return t('syncronization-list-category-new-salesman-orden');
    }
    return '';
  };

  const SynchronizationIcon = () => {
    if (item.workflow === 'customer-registration') {
      return (
        <ProfileIcon strokeColor="#FFFFFF" fillColor="#0088FF" width={30} />
      );
    }
    if (item.workflow === 'salesman-order') {
      return <SalesOrderIcon width={30} />;
    }
    return (
      <PaymentsIcon strokeColor="#FFFFFF" fillColor="#0088FF" width={30} />
    );
  };

  const StatusIcon = () => {
    if (status === 'sending') {
      return <ArrowRightIcon />;
    }
    if (status === 'failed') {
      return <RejectedIcon size={30} />;
    }
    return null;
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        width="100%"
        backgroundColor={getStripedColor()}
        paddingY={3}
        paddingX={5}
        minHeight={21}>
        <VStack flex={1}>
          <HStack>
            <Box marginTop={1}>
              <StatusIcon />
            </Box>
            <Box justifyContent="center" marginLeft={2}>
              <Heading fontSize={20} color="#4C4C4C">
                {getName()}
              </Heading>
              <Heading fontSize={14} color="gray.400" fontWeight={'bold'}>
                {getCategory()}
              </Heading>
            </Box>
          </HStack>
        </VStack>
        <VStack paddingTop={1}>
          <SynchronizationIcon />
        </VStack>
      </HStack>
    </Pressable>
  );
};

export default WithoutConnectionRequestListItem;
